import React, { useState, useContext } from 'react';
import styled from 'styled-components';
import { useMutation } from '@apollo/react-hooks';
import toast from 'react-hot-toast';
import { getErrorMessage } from '../../util/ErrorUtil';
import Button from '../Button';
import colors from '../../styles/colors';
import { AppContext } from '../../context/AppContext';
import { DELETE_ROLE, GET_ORGANIZATION_ROLES } from '../../graphql/queries';
import Error from '../Error';
import UserInfo from '../UserInfo';

const Container = styled.div`
  padding: 20px 15px;
`;

const UserContainer = styled.div`
  margin-bottom: 30px;
`;

const Text = styled.div`
  font-size: 1.4rem;
  font-weight: 600;
  color: ${colors.grey1};
  margin-bottom: 5px;
`;

// const SubText = styled.div`
//   font-size: 1.4rem;
//   color: ${colors.grey3};
// `;

const RoleText = styled.div`
  margin-top: 10px;
  font-size: 1.4rem;
  color: ${colors.grey3};
`;

export default function EditRoleModal({ close }) {
  const { app } = useContext(AppContext);
  const [errorMsg, setErrorMsg] = useState('');
  const [deleteRole, { loading }] = useMutation(DELETE_ROLE, {
    refetchQueries: [{ query: GET_ORGANIZATION_ROLES }],
    onError(error) {
      setErrorMsg(getErrorMessage(error));
    },
    onCompleted(data) {
      console.log(data);
      toast.success('Removed Successfully');
      close();
    },
  });

  console.log(app?.selectedRole);

  return (
    <Container>
      <UserContainer>
        {app?.selectedRole?.userId
          ? (
            <UserInfo
              firstName={app?.selectedRole?.user.firstName}
              lastName={app?.selectedRole?.user.lastName}
              phoneNumber={app?.selectedRole?.user.phoneNumber}
            />
          )
          : (
            <UserInfo
              phoneNumber={app?.selectedRole?.phoneNumber}
            />
          )}
        <RoleText>
          {app?.selectedRole?.accessLevel}
        </RoleText>
      </UserContainer>
      <Text>
        What would you like to do?
      </Text>
      {/* <SubText>
        If you mess up, you can always add them back.
      </SubText> */}
      <Button
        margin="30px 0px 0px 0px"
        text="Remove from Organization"
        width="100%"
        loading={loading}
        onClick={() => {
          deleteRole({
            variables: {
              roleId: app?.selectedRole._id,
            },
          });
        }}
      />
      {/* <Button
        margin="20px 0px 0px 0px"
        text="Edit Organization Role"
        width="100%"
        onClick={() => close()}
      /> */}
      {errorMsg
          && (
            <Error
              error={errorMsg}
              margin="20px 0px 0px 0px"
            />
          )}
    </Container>
  );
}
